<template>
    <div class="row">
        <div class="col-md-12">
            <p>
                Please review and sign the patient agreement(s) below. As the primary member of the account, you can also sign on behalf of family members (if applicable). 
                Once completed, a copy of the signed agreement(s) will be made available in your member dashboard under the 'Documents' tab to download and/or print.
            </p>
        </div>        
        <div class="col-md-12">
            <p>
                <strong style="font-weight: bold!important;">
                    Accresa is not a party to any Membership Agreement, contract or any other document; and therefore, 
                    Accresa has no right to enforce any of its content or terms, and is not liable under any of its terms. 
                    A Membership Agreement, contract or other document is strictly between the Patient and the Healthcare Provider. 
                    Accresa does not assume any liability for any acts, omissions, errors or claims arising out of such Membership Agreement, contract or other document.
                </strong>
            </p>
        </div>        
        <div class="col-md-12">
            <div class="row">
                <div v-if="!isImpersonating" class="col-lg-2">
                    <div class="form-group">
                        <label>Signature</label><br />
                        <input type="text" class="form-control" placeholder="Signature" v-model="signature">
                        <small class="acressaRedText" v-if="!isValidSignature && signature">
                            Signatures cannot includenumbers or special characters
                        </small>
                    </div>
                </div>
                <div v-if="!isImpersonating" class="col-lg-2">
                    <div class="form-group">
                        <label>Sign Date</label><br />
                        <input type="text" class="form-control" :placeholder="signDate" v-model="signDate" disabled>
                    </div>
                </div>
                <div class="col-lg-8 btn-box d-flex justify-content-end">
                    <div class="form-group">
                        <button v-if="!isImpersonating" class="btn btn-sm btn-green" @click.prevent="acceptAll">SIGN AGREEMENTS</button>
                        <slot name="buttons"></slot>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-md-12" v-for="contract in contracts">
            <div class="row" style="margin-bottom: 10px;">
                <div class="col-md-12">
                    <a href="#" @click.prevent="downloadContract(contract)">
                        <i class="fa fa-file-pdf-o acressaRedText"></i>
                        <span>{{ contract.contractName }}</span>
                    </a>
                </div>
                <div class="col-md-12">
                    Associated Patient: {{ contract.participant }}
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { common } from "../../../global/common.js";
import _ from "lodash";
import AcButton from "../../../global/customHtmlElements/AcButton.vue";
import { formatter } from "../../../global/formatter.js";
import {notifications} from "../../../global/notifications.js";
import {impersonationHelper} from "../../../global/impersonation.js";

export default {
    name: "Contracts",
    components: { AcButton },
    props: {
        consumerId: { required: true, type: [Number] }, contracts: { required: true, type: [Array] },
        shoppingCartItems: { required: false, type: [Array], default: () => [] }
    },
    data() {
        return {
            signature: null,
            signDate: formatter.getTodaysDate()
        }
    },
    computed: {
        isImpersonating() {
            return impersonationHelper.isImpersonating();
        },
        isValidSignature() {
            let regExp = /^[a-zA-Z][a-zA-Z\s]*$/;
            return this.hasValue(this.signature) && this.signature.match(regExp);
        }
    },
    methods: {
        downloadContract(contract) {
            let filePath = `ConsumerContracts/${this.consumerId}/Download`;
            let data = "[" + JSON.stringify(contract) + "," +
                JSON.stringify(this.shoppingCartItems) + "]";
            common.downloadFile(filePath, `${contract.contractName}`, data);
        },
        acceptAll() {
            if (!this.validSignature()) return false;
            this.$emit("contracts-accepted", { contracts: this.contracts, signature: this.signature, signatureDate: this.signDate });
        },
        validSignature() {
            if (!this.hasValue(this.signature)) {
                notifications.show({
                        title: "Patient Agreements",
                        message: "Unable to sign: signature is missing"
                    },
                    common.ACRESSA_NOTIFICATIONS.ERROR);
                return false;
            }
            return true;
        },
    }

}
</script>

<style scoped>
.btn-box {
    text-align: -webkit-right;    
    text-align: right;
    padding-top:20px;

}
</style>